var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "21.2mm",
    height: "21.2mm",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-362",
    x: 8.1,
    y: 9.1,
    width: 43.8,
    height: 43.8,
    rx: 10,
    ry: 10,
    transform: "translate(-13.1 30.3) rotate(-45)",
    strokeWidth: 0,
    fill: "#1d1d1b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-372",
    x: 9.7,
    y: 8.4,
    width: 40.6,
    height: 40.6,
    rx: 10,
    ry: 10,
    transform: "translate(-11.5 29.6) rotate(-45)",
    strokeWidth: 0,
    fill: "#f59e00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7,22.5c-.8-.8-2.1-.8-2.9,0l-11.8,11.4-6.3-6.3c-.8-.8-2.1-.8-2.9,0s-.8,2.1,0,2.9l7.7,7.7c.1.1.3.2.4.3,0,0,.2.1.2.2.2.1.5.2.8.2s.5,0,.8-.1c0,0,.1-.1.2-.1.2,0,.3-.2.4-.3l13.2-12.8c.8-.8.8-2.1,0-2.9Z",
    strokeWidth: 0,
    fill: "#82368c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkUpIcon);
export default __webpack_public_path__ + "static/media/OKUpIcon.a099f7f1ccebfa8b7a57913f2d424853.svg";
export { ForwardRef as ReactComponent };